module.exports = __webpack_public_path__ + "static/media/login-back-adm-mobile.27a6feda.jpg";